import memories1 from "../../Assets/images/Memories1.png"
import memories2 from "../../Assets/images/Memories2.png"
import memories3 from "../../Assets/images/Memories3.png"
import memories4 from "../../Assets/images/Memories4.png"
export const memoriesImages = [{
        id: 1,
        memoryImage: memories1,
    },
    {   
        id: 2,
        memoryImage: memories2,
    },
    {
        id: 3,
        memoryImage: memories3,
    },
    {
        id: 4,
        memoryImage: memories4
    }

]